import { useQuery } from "@tanstack/react-query";
import { reportingService } from "@/services/reportingService";

/** Backend v2.1 (Sprint 4.3) Reporting Read Model - metadata for already-persisted reports only, never generates one. */
export function useAvailableReports(portfolioId: string) {
  return useQuery({
    queryKey: ["reports", "available", portfolioId],
    queryFn: () => reportingService.getAvailableReports(portfolioId),
  });
}

export function useReportMetadata(portfolioId: string, reportName: string, enabled = true) {
  return useQuery({
    queryKey: ["reports", "metadata", portfolioId, reportName],
    queryFn: () => reportingService.getReportMetadata(portfolioId, reportName),
    enabled,
  });
}
